const NS = 'WoolArticleCarouselBlock';
const CLS = 'woolArticleCarouselBlock';

export class WoolArticleCarouselBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$sliderContainer = this.$element.find(`.${CLS}-sliderContainer`);
		this.$carouselItems = this.$element.find(`.${CLS}-item`);
		this.$carouselSlider = this.$element.find(`.${CLS}-slider`);
		this.autoSlide = this.$element.data(`autoSlide`);
		if(this.autoSlide === "False"){
			this.autoSlide = false;
		}
		else{
			this.autoSlide = true;
		}
		// init slider
		this.$carouselSlider.slick({
			dots: true,
			dotsClass: `slick-dots`,
			autoplay: this.autoSlide,
  			autoplaySpeed: 5000,
			appendArrows: this.$sliderContainer,
			appendDots: this.$sliderContainer,
			nextArrow: `<button type="button" class="slick-arrow slick-arrow--next"><i class="slick-arrow-icon icon icon--chevron-lg-right"></i></button>`,
			prevArrow: `<button type="button" class="slick-arrow slick-arrow--previous"><i class="slick-arrow-icon icon icon--chevron-lg-left"></i></button>`,
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			cssEase: 'ease-in-out',
			useTransform: true,
			adaptiveHeight: true,
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					infinite: true,
					dots: true
				  }
				},
				{
				  breakpoint: 767,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				  }
				}
			  ]
		});
	}
}
